module.exports = __webpack_public_path__ + "img/T10-P.74b14633.png";